import { ElementRef } from '@angular/core';
import {
    LtGeoData,
    ltMapReeferColorRanges,
    updateLtMapPolygonStyle,
} from '../../models';
import * as Utils from './lt-graph-map-utils';

export const renderMap = (
    container: ElementRef<any>,
    geoJson: any,
    data: LtGeoData[],
): void => {
    const colorAdded = updateLtMapPolygonStyle(ltMapReeferColorRanges, data);

    Utils.createGraph(container, geoJson, colorAdded);
};
